module.exports = __webpack_public_path__ + "img/Blue-L-3@2x.e0d0fe2a.png";